import { Box, Popover as ChakraPopover, PopoverContent, PopoverTrigger } from "@chakra-ui/react";
import { RichtextAdapter } from "modules/storyblok/adapters";
import { isEmpty } from "modules/storyblok/adapters/RichtextAdapter/utils";
import { InfoIcon } from "styles/icons";
import type { SbEditableComponentProps } from "types/storyblok";
import type { PopoverProps } from "./Popover.d";
import { customStyles } from "./Popover.styles";

export const Popover = ({
  content,
  sbEditable,
  backgroundColor,
  color,
  iconColor,
}: SbEditableComponentProps<PopoverProps>) => (
  <ChakraPopover trigger="hover" placement="top-start" {...sbEditable}>
    <PopoverTrigger>
      <Box as="span" role="button">
        <InfoIcon ml={0.5} mb={1} color={iconColor} boxSize={3.5} />
      </Box>
    </PopoverTrigger>
    <PopoverContent bg={backgroundColor} px={6} py={4} sx={{ p: { color }, color }}>
      {!isEmpty(content) && <RichtextAdapter content={content} customStyles={customStyles} />}
    </PopoverContent>
  </ChakraPopover>
);
